import {ValueObject} from '@s-ui/domain'

export class UploadAvatarResponseUserValueObject extends ValueObject {
  #userId
  #url

  /**
   * @param {String} id
   * @param {String} url
   * */
  static create({id, url}) {
    return new UploadAvatarResponseUserValueObject({id, url})
  }

  constructor({id, url}) {
    super()

    this.#userId = id
    this.#url = url
  }

  toJSON() {
    return {
      userId: this.#userId,
      url: this.#url
    }
  }
}
